import React, { useState } from "react";
import { Bookmark, BookmarkCheck } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { cn } from "../lib/utils";

export default function BookmarkButton({ itemType, itemId, title, initial = false, className }) {
  const { user, login } = useAuth();
  const [saved, setSaved] = useState(initial);
  const [busy, setBusy] = useState(false);

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      toast("Sign in to save bookmarks");
      login();
      return;
    }
    setBusy(true);
    try {
      if (saved) {
        await api.delete(`/bookmarks/${itemType}/${itemId}`);
        setSaved(false);
        toast("Removed from bookmarks");
      } else {
        await api.post("/bookmarks", { item_type: itemType, item_id: itemId, title });
        setSaved(true);
        toast("Saved to bookmarks");
      }
    } catch {
      toast.error("Something went wrong");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={toggle}
      disabled={busy}
      data-testid={`bookmark-btn-${itemId}`}
      className={cn(
        "inline-flex items-center gap-2 border px-3 py-2 text-xs transition-colors",
        saved ? "border-gold text-gold" : "border-edge text-muted hover:border-gold hover:text-gold",
        className
      )}
    >
      {saved ? <BookmarkCheck className="h-4 w-4" /> : <Bookmark className="h-4 w-4" />}
      {saved ? "Saved" : "Save"}
    </button>
  );
}
